import { Box, BoxProps } from "@chakra-ui/react";

export default function APLink({ sx, children, ...others }: BoxProps) {
  return (
    <Box
      sx={{
        borderColor: "primary",
        borderBottom: "1px solid",
        fontSize: "0.875rem",
        cursor: "pointer",
        width: "fit-content",
        ...sx,
      }}
      {...others}
    >
      {children}
    </Box>
  );
}
